// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_intraday_market_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BiddingInterconnectionCapacities, BiddingMarketContract, BiddingMarketContractSummary, BiddingMarketOrderBook, BiddingMarketProduct } from "./bidding_intraday_market_model_pb";
import { file_bffuser_v1_bidding_intraday_market_model } from "./bidding_intraday_market_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Empty } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_intraday_market_service.proto.
 */
export const file_bffuser_v1_bidding_intraday_market_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bffuser_v1_bidding_intraday_market_model, file_buf_validate_validate, file_google_protobuf_empty, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListBiddingMarketOrderBookRequest
 */
export type ListBiddingMarketOrderBookRequest = Message<"bffuser.v1.ListBiddingMarketOrderBookRequest"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketOrderBookRequest.
 * Use `create(ListBiddingMarketOrderBookRequestSchema)` to create a new message.
 */
export const ListBiddingMarketOrderBookRequestSchema: GenMessage<ListBiddingMarketOrderBookRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 0);

/**
 * @generated from message bffuser.v1.ListBiddingMarketOrderBookResponse
 */
export type ListBiddingMarketOrderBookResponse = Message<"bffuser.v1.ListBiddingMarketOrderBookResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingMarketOrderBook order_book = 1;
   */
  orderBook?: BiddingMarketOrderBook;
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketOrderBookResponse.
 * Use `create(ListBiddingMarketOrderBookResponseSchema)` to create a new message.
 */
export const ListBiddingMarketOrderBookResponseSchema: GenMessage<ListBiddingMarketOrderBookResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 1);

/**
 * @generated from message bffuser.v1.ListBiddingInterconnectionCapacitiesRequest
 */
export type ListBiddingInterconnectionCapacitiesRequest = Message<"bffuser.v1.ListBiddingInterconnectionCapacitiesRequest"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;
};

/**
 * Describes the message bffuser.v1.ListBiddingInterconnectionCapacitiesRequest.
 * Use `create(ListBiddingInterconnectionCapacitiesRequestSchema)` to create a new message.
 */
export const ListBiddingInterconnectionCapacitiesRequestSchema: GenMessage<ListBiddingInterconnectionCapacitiesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 2);

/**
 * @generated from message bffuser.v1.ListBiddingInterconnectionCapacitiesResponse
 */
export type ListBiddingInterconnectionCapacitiesResponse = Message<"bffuser.v1.ListBiddingInterconnectionCapacitiesResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingInterconnectionCapacities capacities = 1;
   */
  capacities?: BiddingInterconnectionCapacities;
};

/**
 * Describes the message bffuser.v1.ListBiddingInterconnectionCapacitiesResponse.
 * Use `create(ListBiddingInterconnectionCapacitiesResponseSchema)` to create a new message.
 */
export const ListBiddingInterconnectionCapacitiesResponseSchema: GenMessage<ListBiddingInterconnectionCapacitiesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 3);

/**
 * @generated from message bffuser.v1.ListBiddingMarketContractsRequest
 */
export type ListBiddingMarketContractsRequest = Message<"bffuser.v1.ListBiddingMarketContractsRequest"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketContractsRequest.
 * Use `create(ListBiddingMarketContractsRequestSchema)` to create a new message.
 */
export const ListBiddingMarketContractsRequestSchema: GenMessage<ListBiddingMarketContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 4);

/**
 * @generated from message bffuser.v1.ListBiddingMarketContractsResponse
 */
export type ListBiddingMarketContractsResponse = Message<"bffuser.v1.ListBiddingMarketContractsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingMarketContract contracts = 1;
   */
  contracts: BiddingMarketContract[];
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketContractsResponse.
 * Use `create(ListBiddingMarketContractsResponseSchema)` to create a new message.
 */
export const ListBiddingMarketContractsResponseSchema: GenMessage<ListBiddingMarketContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 5);

/**
 * @generated from message bffuser.v1.ListBiddingMarketProductsRequest
 */
export type ListBiddingMarketProductsRequest = Message<"bffuser.v1.ListBiddingMarketProductsRequest"> & {
  /**
   * 受渡日 (= この日の 48 コマ分の状態を返す)。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketProductsRequest.
 * Use `create(ListBiddingMarketProductsRequestSchema)` to create a new message.
 */
export const ListBiddingMarketProductsRequestSchema: GenMessage<ListBiddingMarketProductsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 6);

/**
 * @generated from message bffuser.v1.ListBiddingMarketProductsResponse
 */
export type ListBiddingMarketProductsResponse = Message<"bffuser.v1.ListBiddingMarketProductsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingMarketProduct products = 1;
   */
  products: BiddingMarketProduct[];
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketProductsResponse.
 * Use `create(ListBiddingMarketProductsResponseSchema)` to create a new message.
 */
export const ListBiddingMarketProductsResponseSchema: GenMessage<ListBiddingMarketProductsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 7);

/**
 * @generated from message bffuser.v1.ListBiddingMarketContractSummariesRequest
 */
export type ListBiddingMarketContractSummariesRequest = Message<"bffuser.v1.ListBiddingMarketContractSummariesRequest"> & {
  /**
   * 受渡日 (= この日の 48 コマ分の約定サマリを返す)。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketContractSummariesRequest.
 * Use `create(ListBiddingMarketContractSummariesRequestSchema)` to create a new message.
 */
export const ListBiddingMarketContractSummariesRequestSchema: GenMessage<ListBiddingMarketContractSummariesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 8);

/**
 * @generated from message bffuser.v1.ListBiddingMarketContractSummariesResponse
 */
export type ListBiddingMarketContractSummariesResponse = Message<"bffuser.v1.ListBiddingMarketContractSummariesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingMarketContractSummary summaries = 1;
   */
  summaries: BiddingMarketContractSummary[];
};

/**
 * Describes the message bffuser.v1.ListBiddingMarketContractSummariesResponse.
 * Use `create(ListBiddingMarketContractSummariesResponseSchema)` to create a new message.
 */
export const ListBiddingMarketContractSummariesResponseSchema: GenMessage<ListBiddingMarketContractSummariesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 9);

/**
 * NotifyMarket stream の request。 現時点でパラメータなし。
 *
 * @generated from message bffuser.v1.NotifyMarketRequest
 */
export type NotifyMarketRequest = Message<"bffuser.v1.NotifyMarketRequest"> & {
};

/**
 * Describes the message bffuser.v1.NotifyMarketRequest.
 * Use `create(NotifyMarketRequestSchema)` to create a new message.
 */
export const NotifyMarketRequestSchema: GenMessage<NotifyMarketRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 10);

/**
 * NotifyMarket stream の response (BFF mirror)。
 * thin hint event — frontend がイベント受信で対象コマを unary refetch する。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse
 */
export type NotifyMarketResponse = Message<"bffuser.v1.NotifyMarketResponse"> & {
  /**
   * @generated from oneof bffuser.v1.NotifyMarketResponse.data
   */
  data: {
    /**
     * @generated from field: bffuser.v1.NotifyMarketResponse.Payload payload = 1;
     */
    value: NotifyMarketResponse_Payload;
    case: "payload";
  } | {
    /**
     * keep-alive (= 接続維持用の空メッセージ)。
     *
     * @generated from field: google.protobuf.Empty keep_alive = 2;
     */
    value: Empty;
    case: "keepAlive";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.
 * Use `create(NotifyMarketResponseSchema)` to create a new message.
 */
export const NotifyMarketResponseSchema: GenMessage<NotifyMarketResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11);

/**
 * 受渡日 + コマ番号のペア。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse.DeliveryDateTime
 */
export type NotifyMarketResponse_DeliveryDateTime = Message<"bffuser.v1.NotifyMarketResponse.DeliveryDateTime"> & {
  /**
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.DeliveryDateTime.
 * Use `create(NotifyMarketResponse_DeliveryDateTimeSchema)` to create a new message.
 */
export const NotifyMarketResponse_DeliveryDateTimeSchema: GenMessage<NotifyMarketResponse_DeliveryDateTime> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11, 0);

/**
 * ゲート事前クローズ通知。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse.GatePreClose
 */
export type NotifyMarketResponse_GatePreClose = Message<"bffuser.v1.NotifyMarketResponse.GatePreClose"> & {
  /**
   * @generated from field: repeated bffuser.v1.NotifyMarketResponse.DeliveryDateTime delivery_date_times = 1;
   */
  deliveryDateTimes: NotifyMarketResponse_DeliveryDateTime[];
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.GatePreClose.
 * Use `create(NotifyMarketResponse_GatePreCloseSchema)` to create a new message.
 */
export const NotifyMarketResponse_GatePreCloseSchema: GenMessage<NotifyMarketResponse_GatePreClose> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11, 1);

/**
 * ゲートクローズ通知。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse.GateClosed
 */
export type NotifyMarketResponse_GateClosed = Message<"bffuser.v1.NotifyMarketResponse.GateClosed"> & {
  /**
   * @generated from field: repeated bffuser.v1.NotifyMarketResponse.DeliveryDateTime delivery_date_times = 1;
   */
  deliveryDateTimes: NotifyMarketResponse_DeliveryDateTime[];
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.GateClosed.
 * Use `create(NotifyMarketResponse_GateClosedSchema)` to create a new message.
 */
export const NotifyMarketResponse_GateClosedSchema: GenMessage<NotifyMarketResponse_GateClosed> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11, 2);

/**
 * 板更新通知。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse.MarketBidUpdated
 */
export type NotifyMarketResponse_MarketBidUpdated = Message<"bffuser.v1.NotifyMarketResponse.MarketBidUpdated"> & {
  /**
   * @generated from field: repeated bffuser.v1.NotifyMarketResponse.DeliveryDateTime delivery_date_times = 1;
   */
  deliveryDateTimes: NotifyMarketResponse_DeliveryDateTime[];
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.MarketBidUpdated.
 * Use `create(NotifyMarketResponse_MarketBidUpdatedSchema)` to create a new message.
 */
export const NotifyMarketResponse_MarketBidUpdatedSchema: GenMessage<NotifyMarketResponse_MarketBidUpdated> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11, 3);

/**
 * 約定更新通知。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse.MarketContractUpdated
 */
export type NotifyMarketResponse_MarketContractUpdated = Message<"bffuser.v1.NotifyMarketResponse.MarketContractUpdated"> & {
  /**
   * @generated from field: repeated bffuser.v1.NotifyMarketResponse.DeliveryDateTime delivery_date_times = 1;
   */
  deliveryDateTimes: NotifyMarketResponse_DeliveryDateTime[];
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.MarketContractUpdated.
 * Use `create(NotifyMarketResponse_MarketContractUpdatedSchema)` to create a new message.
 */
export const NotifyMarketResponse_MarketContractUpdatedSchema: GenMessage<NotifyMarketResponse_MarketContractUpdated> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11, 4);

/**
 * イベント本体。
 *
 * @generated from message bffuser.v1.NotifyMarketResponse.Payload
 */
export type NotifyMarketResponse_Payload = Message<"bffuser.v1.NotifyMarketResponse.Payload"> & {
  /**
   * @generated from oneof bffuser.v1.NotifyMarketResponse.Payload.event
   */
  event: {
    /**
     * @generated from field: bffuser.v1.NotifyMarketResponse.GatePreClose gate_pre_close = 1;
     */
    value: NotifyMarketResponse_GatePreClose;
    case: "gatePreClose";
  } | {
    /**
     * @generated from field: bffuser.v1.NotifyMarketResponse.GateClosed gate_closed = 2;
     */
    value: NotifyMarketResponse_GateClosed;
    case: "gateClosed";
  } | {
    /**
     * 連系線更新 (コマ非依存)。
     *
     * @generated from field: google.protobuf.Empty interconnection_lines_updated = 3;
     */
    value: Empty;
    case: "interconnectionLinesUpdated";
  } | {
    /**
     * @generated from field: bffuser.v1.NotifyMarketResponse.MarketBidUpdated market_bid_updated = 4;
     */
    value: NotifyMarketResponse_MarketBidUpdated;
    case: "marketBidUpdated";
  } | {
    /**
     * @generated from field: bffuser.v1.NotifyMarketResponse.MarketContractUpdated market_contract_updated = 5;
     */
    value: NotifyMarketResponse_MarketContractUpdated;
    case: "marketContractUpdated";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.NotifyMarketResponse.Payload.
 * Use `create(NotifyMarketResponse_PayloadSchema)` to create a new message.
 */
export const NotifyMarketResponse_PayloadSchema: GenMessage<NotifyMarketResponse_Payload> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_service, 11, 5);

/**
 * 時間前市場データ (板 / 連系線 / ティッカー / コマ状態) を frontend 向けに提供する service。
 * 市場データは全社共通のため organization_id を持たない。
 * 認証は interceptor 任せ。
 *
 * @generated from service bffuser.v1.BiddingIntradayMarketService
 */
export const BiddingIntradayMarketService: GenService<{
  /**
   * 板 (1 コマ分の注文一覧) を取得。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketOrderBook
   */
  listBiddingMarketOrderBook: {
    methodKind: "unary";
    input: typeof ListBiddingMarketOrderBookRequestSchema;
    output: typeof ListBiddingMarketOrderBookResponseSchema;
  },
  /**
   * 連系線容量一覧を取得。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingInterconnectionCapacities
   */
  listBiddingInterconnectionCapacities: {
    methodKind: "unary";
    input: typeof ListBiddingInterconnectionCapacitiesRequestSchema;
    output: typeof ListBiddingInterconnectionCapacitiesResponseSchema;
  },
  /**
   * ティッカー (約定履歴) 一覧を取得。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketContracts
   */
  listBiddingMarketContracts: {
    methodKind: "unary";
    input: typeof ListBiddingMarketContractsRequestSchema;
    output: typeof ListBiddingMarketContractsResponseSchema;
  },
  /**
   * コマ取引状態一覧 (48 コマ分) を取得。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketProducts
   */
  listBiddingMarketProducts: {
    methodKind: "unary";
    input: typeof ListBiddingMarketProductsRequestSchema;
    output: typeof ListBiddingMarketProductsResponseSchema;
  },
  /**
   * コマ別 約定サマリ一覧 (48 コマ分) を取得。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketContractSummaries
   */
  listBiddingMarketContractSummaries: {
    methodKind: "unary";
    input: typeof ListBiddingMarketContractSummariesRequestSchema;
    output: typeof ListBiddingMarketContractSummariesResponseSchema;
  },
  /**
   * 市場更新イベントを server-stream で通知 (ebalance 初の streaming RPC)。
   * frontend がイベント受信時に unary refetch する thin hint 方式。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayMarketService.NotifyMarket
   */
  notifyMarket: {
    methodKind: "server_streaming";
    input: typeof NotifyMarketRequestSchema;
    output: typeof NotifyMarketResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_bidding_intraday_market_service, 0);

